 import tinymce from 'tinymce';


 import 'tinymce/icons/default';

 
 import 'tinymce/themes/silver';

 
 //import 'tinymce/skins/ui/tinymce-5/skin.css';

 
 import 'tinymce/plugins/advlist';
 import 'tinymce/plugins/code';
 import 'tinymce/plugins/emoticons';
 import 'tinymce/plugins/emoticons/js/emojis';
 import 'tinymce/plugins/link';
 import 'tinymce/plugins/lists';
 import 'tinymce/plugins/table';
 
import 'tinymce/models/dom/index.js'; 
import 'tinymce/models/dom/model.js';

 
 
 
 
  

 
 import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
 import contentCss from 'tinymce/skins/content/default/content.css';

 
 export function render () {
    tinymce.init({
      selector: 'textarea.tinymceEditor',
      plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'styles blocks  | bold italic underline strikethrough | link image media table | align  | numlist bullist | charmap ',
    content_css: 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css',
    style_formats: [
    { title: 'Info box', block: 'div' , classes: ['alert alert-info']},
    { title: 'Danger box', block: 'div' , classes: ['alert alert-danger']},
    { title: 'Warning box', block: 'div' , classes: ['alert alert-warning']},
  ],
  // The following option is used to append style formats rather than overwrite the default style formats.
  style_formats_merge: false,
  promotion: false,

    });
 };